import Client from './Client';

export default class CertClient {
  constructor() {
    this.client = Client;
  }

  /**
   * 获取证书列表
   */
  async getList(data) {
    const res = await this.client.post('/api/user/course/cert/pageBackend', data);
    return res;
  }

  /**
   * 新增修改后台证书
   *
   */
  async upsertCert(data) {
    const res = await this.client.post('/api/user/course/cert/upsertBackend', data);
    return res;
  }

  /**
   * 课程列表
   *
   */
  async listCourseNameByCert(data) {
    const res = await this.client.post('/api/course/listCourseNameByCert', data);
    return res;
  }

  /**
   * 获取证书详情
   *
   */
  async getUserCourseCertDetail(data) {
    const res = await this.client.post('/api/user/course/cert/getUserCourseCertDetail', data);
    return res;
  }

  /**
   * 删除证书
   *
   */
  async deleteCourseCert(data) {
    const res = await this.client.post('/api/user/course/cert/deleteCourseCert', data);
    return res;
  }

  /**
   * 修改视频是否在证书上显示
   *
   */
  async updateIsOnCert(data) {
    const res = await this.client.post('/api/exam/updateIsOnCert', data);
    return res;
  }

  /**
   * 线下课程列表
   *
   */
  async offlineCourse(data) {
    const res = await this.client.post('/api/offline/course/page', data);
    return res;
  }

  /**
   * 线下课程列表新增修改
   *
   */
  async offlineCourseUpsert(data) {
    const res = await this.client.post('/api/offline/course/upsert', data);
    return res;
  }

  /**
   * 线下课程列表导入
   *
   */
  async certImportExcel(data) {
    const res = await this.client.post('/api/user/course/cert/importExcel', data);
    return res;
  }

  /**
   * 线下视频显示
   *
   */
  async offlineVideoShow(data) {
    const res = await this.client.post('/api/cert/offline/video/show', data);
    return res;
  }

  /**
   * 线上视频隐藏
   *
   */
  async offlineVideoHide(data) {
    const res = await this.client.post('/api/cert/offline/video/hide', data);
    return res;
  }

  /**
   * 线上视频删除
   *
   */
  async deleteVideoOffline(data) {
    const res = await this.client.post('/api/cert/offline/video/delete', data);
    return res;
  }

  /**
   * 线上视频新增修改
   *
   */
  async deleteVideoUpsert(data) {
    const res = await this.client.post('/api/cert/offline/video/upsert', data);
    return res;
  }
}